// axios请求接口
import axios from 'axios'

// 登录接口post
export function goLogin(data) {
  return axios({
    url: `/api/sso/login`,
    method: 'post',
    params: data
  })
}
// 登录接口get
export function getLogin(data) {
  return axios({
    url: `/api/sso/login`,
    method: 'get',
    params: data
  })
}

// 刷新token
export function getToken() {
  return axios({
    url: `/api/sso/refreshToken`,
    method: 'get'
  })
}
// 获取用户级别
export function getUserLevel(username) {
  return axios({
    url: `/api/sso/userLevel?username=${username}`,
    method: 'get'
  })
}